import Sfimgage1 from '../Images/rdfs_banner.png';
// import Toolbar from '../Toolbar/Toolbar';
// import BackDrop from '../Backdrop/Backdrop';
// import SideDrawer from './components/SideDrawer/SideDrawer';
import './Pages.css';
// import Dashboard from './Dashboard';
import Login from './Login';
import Users from './Users';
import '../Global';

import { React, useState } from "react";
import {db} from './Firebase';
import {collection, getDocs, addDoc} from 'firebase/firestore';

// let username='';


const Dashboard = ()=>{
    // const [username, setUsername] = useState(global.userName);
    const [username, setUsername] = useState('');

    // if(username==''){
    //     console.log('Login');
    
    // }else{
    //     console.log('user exist');
    // }
    
   

       return (
        <>
        <div style={{fontSize: '25px', textShadow: '1px 2px 9px blue', textAlign: 'center'}}>
        You are not a dashboard authorized user!
        </div>
            
        </>


    );
}

export default Dashboard;